import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import * as Yup from 'yup';
import { useNavigate, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Button from '../../../../components/Button'
import '../../../../assets/languages/i18n'
import { Box, Grid, Link, Paper, TextField, Toolbar, Typography, InputAdornment, Alert, FormHelperText } from "@mui/material";
import { Formik } from "formik";
import LoginBG from "../../../../assets/images/bg.svg"
import LoginLogo1 from "../../../../assets/images/login/design-stats-pana-1.png"
import UnderConLogo from "../../../../assets/images/login/under-construction.png"
import { useDispatch, useSelector } from "react-redux";
import { useCookies } from 'react-cookie';
import { makeStyles } from "@mui/styles";
import { useFormik } from "formik";
import * as yup from 'yup';
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "../../../../assets/images/closeLogin.svg";
import { ReactComponent as SucessIcon } from "../../../../assets/images/forgotpwd/SucessFwd.svg";
import authService from "../../../../services/auth.service";
import { logout } from "../../../../actions/auth";
import { fetchStartParam, } from "../../../../actions/start";
import * as Util from "../../../../services/global.service";
const styles = {
    toolBar: {
        paddingLeft: "5px",
    },
    childToolBar: {
        padding: "32px 20px",
        fontWeight: '400'
    },
    title: {
        paddingBottom: "5px"
    },
    subTitle: {
        color: "#C4C4C4"
    },
};

const useStyles = makeStyles({
    error: {
        color: " #CC6058 !important",
        "& div > p": {
            color: " #CC6058 !important",
            fontSize: "14px",
            lineHeight: "15.4px",
            marginLeft: 0,
        },
        "& > p": {
            color: " #CC6058 !important",
            fontSize: "14px",
            lineHeight: "15.4px",
            marginLeft: 0,
        },
        "& div > input": {
            fontSize: "14px",
            lineHeight: "15.4px",
        },
        "& div > label": {
            color: "#0C2B34",
            fontSize: "16px",
            lineHeight: "17.6px",
            fontWeight: "500"
        },
    },
    formTextField: {
        '& .MuiTextField-root': { m: 1, width: '25ch' },
    },
    input: {
        '& div > input': {
            height: '8px',
            position: "relative"
        }
    },
    inputError: {
        '& div > input': {
            color: "#CC6058",
            background: "#CC60581A",
            textAlign: "center",
            height: '6px',
            border: "1px solid #CC6058 !important",
            borderRadius: "4px"
        }
    },
    disabled: {
        '& div > input': {
            height: '8px',
            position: "relative"
        },
        '& .Mui-disabled': {
            '-webkit-text-fill-color': '#404349 !important',
            backgroundColor: "#FAFAFA"
        },
        '& .MuiOutlinedInput-notchedOutline': {
            border: "none"
        }
    },
    expire: {
        paddingRight: "20px"
    }
});

const ResetNewPassword = () => {
    const [cookies, setCookie] = useCookies(['member']);
    const classes = useStyles()
    const navigate = useNavigate();
    const { t } = useTranslation()
    let { site } = useParams()
    const dispatch = useDispatch();
    const [changePwd, setChangPwd] = useState(false);
    const [blurFirst, setBlurFirst] = useState(false);
    const [showPasswordNew, setShowPasswordNew] = useState(false);
    const [showPasswordConfrim, setShowPasswordConfrim] = useState(false);
    const [errorPassword, setErrorPassword] = useState(false);
    const handleClickShowPasswordNew = () => setShowPasswordNew(!showPasswordNew);
    const handleMouseDownPasswordNew = () => setShowPasswordNew(!showPasswordNew);
    const handleClickShowPasswordConfrim = () => setShowPasswordConfrim(!showPasswordConfrim);
    const handleMouseDownPasswordConfrim = () => setShowPasswordConfrim(!showPasswordConfrim);
    const dataProfiles = JSON.parse(localStorage.getItem("user"));
    const validationSchema = yup.object().shape(
        {
            passwordNew: yup.string()
                // .required(t('forgotpwd.msg.newPasswords'))
                .required("Please enter your new password")
                // .min(8, t('profile.passwordMust'))
                .min(8, "The password must contain at least 8 characters with a minimum of lower case, upper case, numeric character, and a special character.")
                .matches(
                    /^(?=.*[A-Z])(?=.*\d)(?=.*[a-z])(?=.*[!@#$%^&*()\-_+={`~[\]\\};':/"|,.<?>])[A-Za-z\d!@#$%^&*()\-_+={`~[\]\\};':/"|,.<?>]{8,}$/,
                    // t('profile.passwordMust')),
                    "The password must contain at least 8 characters with a minimum of lower case, upper case, numeric character, and a special character."),
            // passwordConfrim: yup.string().required(t('forgotpwd.msg.confirmNewPassword')).when("passwordNew", {
            passwordConfrim: yup.string().required("Please confirm new password").when("passwordNew", {
                is: val => (val && val.length > 0 ? true : false),
                then: yup.string().oneOf(
                    [yup.ref("passwordNew")],
                    // t('forgotpwd.msg.notmacth')
                    "Confirmed new password doesn’t match"
                )
            })
        }
    )
    useEffect(() => {
        document.getElementById('signin').style.display = "none"
        const myInput = document.getElementById('passwordConfrim');
        myInput.onpaste = e => e.preventDefault();
        if (Util.formatData(site, false) !== false) {
            localStorage.setItem("site", site);
            dispatch(fetchStartParam(site)).then((resp) => {

            })
        }
    }, []);
    const formik = useFormik({
        initialValues: {
            passwordNew: "",
            passwordConfrim: "",
        },
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: (values) => {
            submit(values)
        },
    });

    useEffect(() => {
        if (errorPassword) {
            setErrorPassword(false)
        }
    }, [formik.values.passwordNew]);

    const handleSubmit = () => {
        formik.submitForm()
    }
    const acceptLogin = (data) => {
        navigate(data, { replace: false });
    }
    const goToLogin = () => {
        dispatch(logout()).then(
            (response) => {
                localStorage.removeItem('date');
                localStorage.removeItem('expireDate');
                //navigate('/' + localStorage.getItem("site"), { replace: false });
                window.location.href = '/' + localStorage.getItem("site")
            }
        ).catch((err) => {
            localStorage.removeItem('date');
            localStorage.removeItem('user');
            localStorage.removeItem("proxy");
            //navigate('/' + localStorage.getItem("site"), { replace: false });
            window.location.href = '/' + localStorage.getItem("site")
        })
    }
    const submit = (val) => {
        let dt = {
            user: dataProfiles?.user !== undefined && dataProfiles?.user !== null ? dataProfiles?.user : "",
            username: "",
            pincode: "",
            new_password: val.passwordNew,
            options: {}
        }
        authService.setPassword(dt).then((rs) => {
            if (rs?.success === true) {
                setChangPwd(true)
                localStorage.removeItem("user");

            } else {
            }

        }).catch((err) => {
            if (err?.data?.code === "login.msg.chg_pwd_error") {
                setErrorPassword(true)
            }
        })

    }

    /*** control logic  */
    return (
        <>
            <Helmet>
                <title>Login | PMS</title>
            </Helmet>
            {/*<Box height={1} sx={{}}>*/}
            <Grid container sx={{
                height: '100%',
                'min-height': "600px",
                'backgroundImage': `url(${LoginBG})`,
                'background-size': 'cover',
            }}>
                <Grid container item
                    sx={{
                        display: 'flex',
                        flexDirection: { xs: 'column', lg: 'row' },
                        alignItems: 'center',
                        overflow: 'hidden',
                        boxShadow: 0,
                        fontWeight: 'bold',
                    }}>
                    <Grid container item xs={12} lg={6} justifyContent="center"
                        sx={{ display: { sm: 'none', lg: 'flex' } }} alignItems="center">
                        <img src={LoginLogo1} style={{ maxHeight: "485px" }} />
                    </Grid>
                    <Grid container item xs={12} lg={6} spacing={4} sx={{}}>
                        <Grid direction="column" sx={{}}
                            container item
                            justifyContent="center"
                            alignItems="center">
                            <Grid container item>
                                {/*<Grid container item sx={{}}>*/}
                                {/*    <Alert severity="error">{t('login.msg.sessionTimeout')}</Alert>*/}
                                {/*</Grid>*/}
                                {changePwd === true ?
                                    //stepChangpasswordSucess
                                    <Paper elevation={6} sx={{ padding: '50px', 'borderRadius': '20px', width: '100%', maxWidth: '480px', minHeight: '485px' }}>
                                        <Box sx={{ display: "flex", justifyContent: "center" }}>
                                            <SucessIcon />
                                        </Box>
                                        <Grid justifyContent="center" display="flex" flexDirection="column" alignItems="center">
                                            <Typography
                                                color="primary"
                                                variant="h2"
                                                paddingTop="20px"
                                                style={styles.title}
                                                fontSize={36}
                                                lineHeight="39.6px"
                                                textAlign="center"
                                                dangerouslySetInnerHTML={{ __html: "New password<br> has been set!" }}
                                            >
                                                {/* {t('forgotpwd.label.changePwdSucess')} */}
                                            </Typography>
                                            <Typography
                                                fontSize={14}
                                                lineHeight="21.86px"
                                                pt="15px"
                                            >
                                                {/* {t('forgotpwd.label.NewPwdSucess')} */}
                                                Your new password has been set.
                                            </Typography>
                                            <Typography
                                                pb="40px"
                                                fontSize={14}
                                                lineHeight="21.86px"
                                            >
                                                {/* {t('forgotpwd.label.loginNewPwd')} */}
                                                Please login with your new password to continue.
                                            </Typography>
                                        </Grid>
                                        <Button
                                            color="primary"
                                            fullWidth
                                            size="large"
                                            type="submit"
                                            variant="contained"
                                            sx={{ textTransform: "none" }}
                                            onClick={goToLogin}
                                        >
                                            {/* {t('forgotpwd.label.login')} */}
                                            {/* <Typography
                                                fontSize={18}
                                                lineHeight="19.8px"
                                                color="#FFFFFF"
                                            >
                                                Return to login page
                                            </Typography> */}
                                            Return to login page
                                        </Button>
                                    </Paper>
                                    :
                                    //stepNewpassword 
                                    <Paper elevation={6} sx={{ padding: '50px', 'borderRadius': '20px', width: '100%', maxWidth: '480px', minHeight: '485px' }} >
                                        <Box sx={{ mb: 3 }}>
                                            <Typography
                                                color="primary"
                                                variant="h2"
                                                style={styles.title}
                                                fontSize={36}
                                                lineHeight="39.6px"
                                            >
                                                {/* {t('forgotpwd.label.setNewPassword')} */}
                                                Set New Password
                                            </Typography>
                                            <Typography
                                                gutterBottom
                                                variant="h2"
                                                style={styles.subTitle}
                                                fontSize={16}
                                                fontWeight={400}
                                                lineHeight="23.92px"
                                                color="#C4C4C4"
                                            >
                                                {/* {t('forgotpwd.label.passwordToContinue')} */}
                                                Enter your new password to continue
                                            </Typography>
                                        </Box>
                                        <Grid item sx={{ paddingTop: "0 !important", position: "relative" }} mb="30px">
                                            <Typography variant="subtitle1" fontSize={18} lineHeight="19.8px" color="#404349">
                                                {/* {t('forgotpwd.label.newPassword')} */}
                                                New Password
                                            </Typography>
                                            <Box sx={{ ".MuiFormControl-root": { "margin-bottom": "0px", "margin-top": "7px" } }}>
                                                <TextField
                                                    // error={Boolean(formik.touched.passwordNew && formik.errors.passwordNew)}
                                                    error={errorPassword ? errorPassword : Boolean(formik.touched.passwordNew && formik.errors.passwordNew)}
                                                    fullWidth
                                                    // helperText={formik.touched.passwordNew && formik.errors.passwordNew}
                                                    // label={t("login.label.passwordNew")}
                                                    margin="normal"
                                                    name="passwordNew"
                                                    onBlur={formik.handleBlur}
                                                    onChange={formik.handleChange}
                                                    type={showPasswordNew ? "text" : "password"}
                                                    value={formik.values.passwordNew}
                                                    variant="standard"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    // placeholder={t('forgotpwd.label.newPasswords')}
                                                    placeholder="Enter your new password"
                                                    InputProps={{
                                                        endAdornment: (
                                                            <InputAdornment position="end">
                                                                <IconButton
                                                                    aria-label="toggle password visibility"
                                                                    onClick={handleClickShowPasswordNew}
                                                                    onMouseDown={handleMouseDownPasswordNew}
                                                                >
                                                                    {showPasswordNew ? (
                                                                        <Visibility />
                                                                    ) : (
                                                                        <VisibilityOff />
                                                                    )}
                                                                </IconButton>
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                // classes={{ root: classes.input}}
                                                />
                                                {errorPassword ?
                                                    <FormHelperText error >{t('profile.previousOldPassword')}</FormHelperText>
                                                    :
                                                    formik.touched.passwordNew && formik.errors.passwordNew ? <FormHelperText error >{formik.errors.passwordNew}</FormHelperText> : null
                                                }
                                            </Box>
                                        </Grid>
                                        <Grid item sx={{ paddingTop: "0 !important", position: "relative" }} mb="30px">
                                            <Typography variant="subtitle1" fontSize={18} lineHeight="19.8px" color="#404349">
                                                {/* {t('forgotpwd.label.confirmPwd')} */}
                                                Confirm New Password
                                            </Typography>
                                            <Box sx={{ ".MuiFormControl-root": { "margin-bottom": "0px", "margin-top": "10px" } }}>
                                                <TextField
                                                    error={Boolean(formik.touched.passwordConfrim && formik.errors.passwordConfrim)}
                                                    fullWidth
                                                    helperText={formik.touched.passwordConfrim && formik.errors.passwordConfrim}
                                                    // label={t("login.label.passwordConfrim")}
                                                    id='passwordConfrim'
                                                    margin="normal"
                                                    name="passwordConfrim"
                                                    onBlur={formik.handleBlur}
                                                    onChange={formik.handleChange}
                                                    type={showPasswordConfrim ? "text" : "password"}
                                                    value={formik.values.passwordConfrim}
                                                    variant="standard"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    // placeholder={t('forgotpwd.label.confirmNewPassword')}
                                                    placeholder="Enter your confirm new password"
                                                    InputProps={{
                                                        endAdornment: (
                                                            <InputAdornment position="end">
                                                                <IconButton
                                                                    aria-label="toggle password visibility"
                                                                    onClick={handleClickShowPasswordConfrim}
                                                                    onMouseDown={handleMouseDownPasswordConfrim}
                                                                >
                                                                    {showPasswordConfrim ? (
                                                                        <Visibility />
                                                                    ) : (
                                                                        <VisibilityOff />
                                                                    )}
                                                                </IconButton>
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                // classes={{ root: classes.input}}
                                                />
                                            </Box>
                                        </Grid>
                                        <Box>
                                            <Button
                                                color="primary"
                                                fullWidth
                                                size="large"
                                                type="submit"
                                                variant="contained"
                                                onClick={handleSubmit}
                                                sx={{ textTransform: 'none' }}
                                            >
                                                {/* {t('forgotpwd.label.setNewPassword')} */}
                                                Set New Password
                                            </Button>
                                            <Typography sx={{ textDecoration: 'underline', justifyContent: "center", cursor: 'pointer' }}
                                                color="#A0A0A0"
                                                fontSize={15}
                                                lineHeight="21.86px"
                                                textAlign="center"
                                                paddingTop="20px"
                                                onClick={goToLogin}
                                            >
                                                {/* {t('forgotpwd.label.goToLogin')} */}
                                                Return to login page
                                            </Typography>
                                        </Box>
                                    </Paper>
                                }
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>

                {/*footer*/}
                <Grid container item sx={{
                    bottom: 0
                }}
                >
                    <Toolbar color="primary" sx={{ 'align-items': 'end', 'padding-left': '5px' }} style={styles.toolBar}>
                        <Typography variant="h6" component="div" sx={{ flexGrow: 0 }} p={4} style={styles.childToolBar}>
                            Copyright 2021 I AM Consulting Co., Ltd. All Rights Reserved
                        </Typography>
                    </Toolbar>
                </Grid>
            </Grid>
            {/*</Box>*/}
        </>
    );
};
export default ResetNewPassword;
